module.exports = __webpack_public_path__ + "img/mession-3.5b0aacf6.png";